<template>
  <div>
    <!-- Chargement -->
    <div v-if="loadingGet" class="text-xs-center">
      <v-progress-circular indeterminate class="primary--text" :size="100" :width="1"></v-progress-circular>
    </div>
    
    <!-- Formulaire -->
    <div v-else>
      <v-expansion-panel>
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_facebook')"
        >
          <div slot="header">Facebook</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch disabled v-model="fb_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ fb_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('activeInFacebook') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field v-model="fb_token" label="Token Facebook"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field v-model="fb_id" label="Id Facebook"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_messenger')"
        >
          <div slot="header">Messenger</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch disabled v-model="messenger_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ messenger_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                    <v-list-tile-sub-title>{{ $t('activeInFacebook') }}</v-list-tile-sub-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field v-model="messenger_id" label="Id Messenger"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_salseforce')"
        >
          <div slot="header">Salesforce</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="sf_onoff" ></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ sf_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!sf_onoff" v-model="sf_id1" :label="$t('connectionIdentifier')"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!sf_onoff" v-model="sf_id2" :label="$t('password')"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!sf_onoff" v-model="sf_id3" label="Token"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_zendesk')"
        >
          <div slot="header">Zendesk</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="zd_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ zd_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!zd_onoff" v-model="zd_id1" :label="$t('connectionIdentifier')"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!zd_onoff" v-model="zd_id2" :label="$t('domainName') | cap"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!zd_onoff" v-model="zd_id3" label="Token"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_freshdesk')"
        >
          <div slot="header">Freshdesk</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="ds_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ fd_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!fd_onoff" v-model="fd_id" :label="$t('connectionIdentifier')"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content>
          <div slot="header">Sellsy</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="sy_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ sy_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!sy_onoff" v-model="sy_id" label="Consumer token"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!sy_onoff" v-model="sy_id1" label="Consumer secret"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!sy_onoff" v-model="sy_id2" label="Utilisateur token"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!sy_onoff" v-model="sy_id3" label="Utilisateur secret"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!sy_onoff" v-model="sy_id4" label="Token V2"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-flex sm2>
                  <v-list-tile-content>
                    <v-text-field :disabled="true" v-model="sy_id5" label="Custom Activity"></v-text-field>
                  </v-list-tile-content>
                  </v-flex>
                  <v-flex sm2>
                  <v-btn
                    color="secondary"
                    :disabled="!sy_id4 || sy_id4 === '' || sy_id5 || sy_id5 !== ''"
                    @click.native="customSellsy()">
                    Activer
                  </v-btn>
                  </v-flex>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_analytics')"
        >
          <div slot="header">Analytics</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="ga_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ ga_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!ga_onoff" v-model="ga_id" :label="$t('connectionIdentifier')"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>
        
        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_slack')"
        >
          <div slot="header">Slack</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="slack_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ slack_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!slack_onoff" v-model="slack_id" :label="$t('connectionIdentifier')"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_vyte')"
        >
          <div slot="header">Vyte</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="vyte_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ vyte_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!vyte_onoff" v-model="vyte_id1" label="email"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!vyte_onoff" v-model="vyte_id2" label="Id Application"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!vyte_onoff" v-model="vyte_id3" label="Token"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_calendar')"
        >
          <div slot="header">Google Calendar / Agenda</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="calendar_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ calendar_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="true" v-model="calendar_id1" label="token/email"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="true" v-model="calendar_id2" label="Id Application"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_apz')"
        >
          <div slot="header">Visio-Assistance</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="apz_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ apz_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!apz_onoff" v-model="apz_id" :label="$t('connectionIdentifier')"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

        <v-expansion-panel-content
          :disabled="testBrideStatus('parametre_connecteur_whatsapp')"
        >
          <div slot="header">Whatsapp</div>
          <v-card>
            <v-card-text>
              <v-list two-line>
                <v-list-tile>
                  <v-list-tile-action>
                    <v-switch v-model="whatsapp_onoff"></v-switch>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{ whatsapp_onoff ? 'ON' : 'OFF' }}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-list-tile>
                  <v-list-tile-content>
                    <v-text-field :disabled="!whatsapp_onoff" v-model="whatsapp_id" :label="$t('connectionIdentifier')"></v-text-field>
                  </v-list-tile-content>
                </v-list-tile>
              </v-list>
            </v-card-text>
          </v-card>
        </v-expansion-panel-content>

      </v-expansion-panel>

      <!-- Validation du formulaire -->
      <div class="text-xs-right">
        <v-btn
          color="primary"
          :block="$vuetify.breakpoint.xsOnly"
          :loading="loadingPost"
          @click.native="postOptions()">
          {{ $t('save') | cap }}<v-icon dark right>send</v-icon>
        </v-btn>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  data () {
    return {
      fb_onoff: true,
      fb_token: '',
      fb_id: '',
      messenger_onoff: true,
      messenger_id: '',
      sf_onoff: false,
      sf_id1: '',
      sf_id2: '',
      sf_id3: '',
      zd_onoff: false,
      zd_id1: '',
      zd_id2: '',
      zd_id3: '',
      fd_onoff: false,
      fd_id: '',
      sy_onoff: false,
      sy_id: '',
      sy_id1: '',
      sy_id2: '',
      sy_id3: '',
      zy_onoff: false,
      zy_id1: '',
      zy_id2: '',
      zy_id3: '',
      zy_id: '',
      ga_onoff: false,
      ga_id: '',
      apz_onoff: false,
      apz_id: '',
      whatsapp_onoff: false,
      whatsapp_id: '',
      slack_onoff: false,
      slack_id: '',
      // loaders
      loadingGet: false,
      loadingPost: false,
      vyte_onoff: false,
      vyte_id1: '',
      vyte_id2: '',
      vyte_id3: '',
      calendar_onoff: false,
      calendar_id1: '',
      calendar_id2: '',
      dialogProgress: false
    }
  },

  mounted () {
    this.getOptions()
    // if (!this.$cookie.get('blockInstallProgress') && this.$store.state._User.ongoingTuto) {
    //   this.openDialogProgress()
    // }
  },
  created () {
    /* eslint-disable */
    if (typeof (defautMotif) !== 'undefined') {
      defautMotif = 'settings_connectors'
    }
    else {
      setTimeout (function () {
        if (typeof (defautMotif) !== 'undefined') {
          defautMotif = 'settings_connectors'
        }
      }, 800);
    }
    /* eslint-enable */
  },

  methods: {
    getOptions () {
      this.loadingGet = true
      this.axios
        .get('get/settings_connectors.php')
        .then(response => {
          this.fb_onoff = true
          this.fb_token = response.data.ENT_SOCIALNETWORK_TOKEN
          this.fb_id = response.data.ENT_SOCIALNETWORK_ID
          this.messenger_onoff = true
          this.messenger_id = response.data.ENT_FBMESSENGER_PAGEID
          this.sf_onoff = response.data.ENT_SF === '1' || response.data.ENT_SF === 'salesforce'
          this.sf_id1 = response.data.ENT_SF_ID
          this.sf_id2 = response.data.ENT_SF_ID2
          this.sf_id3 = response.data.ENT_SF_ID3
          this.zd_onoff = response.data.ENT_ZD === '1' || response.data.ENT_ZD === 'zendesk'
          this.zd_id1 = response.data.ENT_ZD_ID
          this.zd_id2 = response.data.ENT_ZD_ID2
          this.zd_id3 = response.data.ENT_ZD_ID3
          this.fd_onoff = response.data.ENT_FD === '1' || response.data.ENT_FD === 'freshdesk'
          this.fd_id = response.data.ENT_FD_ID
          this.ga_onoff = response.data.ENT_GA === '1' || response.data.ENT_GA === 'analytics'
          this.ga_id = response.data.ENT_GA_ID
          this.slack_onoff = response.data.ENT_SLACK === '1' || response.data.ENT_SLACK === 'slack'
          this.slack_id = response.data.ENT_SLACK_ID
          this.vyte_onoff = response.data.ENT_VYTE === '1'
          this.vyte_id1 = response.data.ENT_VYTE_ID
          this.vyte_id2 = response.data.ENT_VYTE_ID2
          this.vyte_id3 = response.data.ENT_VYTE_ID3
          this.calendar_onoff = response.data.ENT_CALENDAR === '1'
          this.calendar_id1 = response.data.ENT_CALENDAR_ID
          this.calendar_id2 = response.data.ENT_CALENDAR_ID2
          this.apz_onoff = response.data.ENT_APZ === '1'
          this.apz_id = response.data.ENT_APZ_KEY
          this.whatsapp_onoff = response.data.ENT_WHATSAPP === '1'
          this.whatsapp_id = ''

          this.sy_onoff = ''
          this.sy_id = ''
          this.sy_id1 = ''
          this.sy_id2 = ''
          this.sy_id3 = ''
          this.sy_id4 = ''
          this.sy_id5 = ''
          if (response.data.ENT_SELLSY !== '') {
            let entSellsy = JSON.parse(response.data.ENT_SELLSY)
            this.sy_onoff = entSellsy.onoff === '1'
            this.sy_id = entSellsy.id
            this.sy_id1 = entSellsy.id1
            this.sy_id2 = entSellsy.id2
            this.sy_id3 = entSellsy.id3
            this.sy_id4 = entSellsy.id4
            this.sy_id5 = entSellsy.id5 ? entSellsy.id5 : ''
          }
        })
        .catch(_ => {})
        .then(_ => {
          this.loadingGet = false
        })
    },

    // test le status de la bride pour afficher le menu
    testBrideStatus (name) {
      // console.log('name', name)
      let brides = this.$store.state._User.brides
      // console.log('brides', brides)
      if (brides) {
        let resultat = brides.find(brides => brides.brideName === name)
        if (resultat) {
          if (resultat.status === '0') {
            return true
          } else {
            return false
          }
        }
      }
    },

    postOptions () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()

      dataToPost.append(
        'DSK_ID',
        this.$store.state._Sites.siteSelected.LIC_DSK_ID
      )
      dataToPost.append(
        'LIC_KEY',
        this.$store.state._Sites.siteSelected.LIC_KEY
      )
      dataToPost.append(
        'LIC_ID',
        this.$store.state._Sites.siteSelected.LIC_ID
      )

      dataToPost.append('ENT_SOCIALNETWORK_TOKEN', this.fb_token)
      dataToPost.append('ENT_SOCIALNETWORK_ID', this.fb_id)
      dataToPost.append('ENT_SF', this.sf_onoff ? '1' : '0')
      dataToPost.append('ENT_SF_ID', this.sf_id1)
      dataToPost.append('ENT_SF_ID2', this.sf_id2)
      dataToPost.append('ENT_SF_ID3', this.sf_id3)
      dataToPost.append('ENT_ZD', this.zd_onoff ? '1' : '0')
      dataToPost.append('ENT_SELLSY_ONOFF', this.sy_onoff ? '1' : '0')
      dataToPost.append('ENT_SELLSY_ID', this.sy_id)
      dataToPost.append('ENT_SELLSY_ID1', this.sy_id1)
      dataToPost.append('ENT_SELLSY_ID2', this.sy_id2)
      dataToPost.append('ENT_SELLSY_ID3', this.sy_id3)
      dataToPost.append('ENT_SELLSY_ID4', this.sy_id4)
      dataToPost.append('ENT_SELLSY_ID5', this.sy_id5)
      dataToPost.append('ENT_ZD_ID', this.zd_id1)
      dataToPost.append('ENT_ZD_ID2', this.zd_id2)
      dataToPost.append('ENT_ZD_ID3', this.zd_id3)
      dataToPost.append('ENT_FD', this.fd_onoff ? '1' : '0')
      dataToPost.append('ENT_FD_ID', this.fd_id)
      dataToPost.append('ENT_GA', this.ga_onoff ? '1' : '0')
      dataToPost.append('ENT_GA_ID', this.ga_id)
      dataToPost.append('ENT_SLACK', this.slack_onoff ? '1' : '0')
      dataToPost.append('ENT_SLACK_ID', this.slack_id)
      dataToPost.append('ENT_FBMESSENGER_PAGEID', this.messenger_id)
      dataToPost.append('ENT_VYTE', this.vyte_onoff ? '1' : '0')
      dataToPost.append('ENT_VYTE_ID', this.vyte_id1)
      dataToPost.append('ENT_VYTE_ID2', this.vyte_id2)
      dataToPost.append('ENT_VYTE_ID3', this.vyte_id3)
      dataToPost.append('ENT_CALENDAR', this.calendar_onoff ? '1' : '0')
      dataToPost.append('ENT_CALENDAR_ID', this.calendar_id1)
      dataToPost.append('ENT_CALENDAR_ID2', this.calendar_id2)
      dataToPost.append('ENT_APZ', this.apz_onoff ? '1' : '0')
      dataToPost.append('ENT_APZ_KEY', this.apz_id)
      dataToPost.append('ENT_WHATSAPP', this.whatsapp_onoff ? '1' : '0')
      this.loadingPost = true
      this.axios
        .post('post/settings_connectors.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loadingPost = false
        })
    },
    customSellsy () {
      // Données modifiées et à renvoyer
      let dataToPost = new window.FormData()

      dataToPost.append('ENT_SELLSY_ONOFF', this.sy_onoff ? '1' : '0')
      dataToPost.append('ENT_SELLSY_ID', this.sy_id)
      dataToPost.append('ENT_SELLSY_ID1', this.sy_id1)
      dataToPost.append('ENT_SELLSY_ID2', this.sy_id2)
      dataToPost.append('ENT_SELLSY_ID3', this.sy_id3)
      dataToPost.append('ENT_SELLSY_ID4', this.sy_id4)
      dataToPost.append('ENT_SELLSY_ID5', this.sy_id5)

      this.loadingPost = true
      this.axios
        .post('post/settings_custom_sellsy.php', dataToPost, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
        })
        .then(response => {
          this.sy_id5 = response.data
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifSuccess'),
            context: 'success'
          })
        })
        .catch(_ => {
          this.sy_id5 = ''
          this.$store.dispatch('_Notifier/NEW_NOTIF', {
            message: this.$t('modifFailure'),
            context: 'error'
          })
        })
        .then(_ => {
          this.loadingPost = false
        })
    },
    // ---------------------------
    // close dialog Progression install
    fermeDialogProgress () {
      this.dialogProgress = false
    },
    // ---------------------------
    // Ouvre la dialogueBox de progression de l'installation
    openDialogProgress () {
      this.dialogProgress = true
    }
  },

  watch: {
    '$store.state._Sites.siteSelected': function (v) {
      if (v) {
        this.getOptions()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/settings/Connectors.vue